import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import { Component } from 'react';
import { matchRoutes } from 'react-router-dom';
import withRouter from '@fuse/core/withRouter';
import history from '@history';
import { homeRouteFor, INVENTORY_LOOKUP_ROLE } from 'app/auth/roleHome';

let loginRedirectUrl = null;

class FuseAuthorization extends Component {
  constructor(props, context) {
    super(props);
    const { routes } = context;
    this.state = {
      accessGranted: true,
      routes,
    };
    this.defaultLoginRedirectUrl = props.loginRedirectUrl || '/';
  }

  componentDidMount() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.accessGranted !== this.state.accessGranted;
  }

  componentDidUpdate() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { location, userRole } = props;
    const { pathname } = location;

    const matchedRoutes = matchRoutes(state.routes, pathname);

    const matched = matchedRoutes ? matchedRoutes[0] : false;
    // PGSS-5715: the backend locks any holder of the Inventory Lookup role to its own endpoints, whatever other
    // role it also holds, so routes are checked as if that were its only role.
    const effectiveRole = homeRouteFor(userRole) ? [INVENTORY_LOOKUP_ROLE] : userRole;
    return {
      accessGranted: matched ? FuseUtils.hasPermission(matched.route.auth, effectiveRole) : true,
    };
  }

  redirectRoute() {
    const { location, userRole, verify } = this.props;
    const { pathname } = location;
    const redirectUrl = loginRedirectUrl || this.defaultLoginRedirectUrl;

    /*
        User is guest
        Redirect to Login Page
        */
    if (!userRole || userRole.length === 0) {
      setTimeout(() => history.push('/sign-in'), 0);
      loginRedirectUrl = pathname;
    } else if (verify) {
      setTimeout(() => history.push('/verify'), 0);
      loginRedirectUrl = pathname;
    } else if (homeRouteFor(userRole)) {
      /*
              PGSS-5715: a role with a single page of its own (Inventory Lookup). The default
              redirect is '/', which bounces to /dashboard -- a route this role cannot open -- so it
              sat on a blank page. Send it to its own page instead. Read the role now, at redirect
              time, so a login that has just completed is honoured.
              */
      const home = homeRouteFor(userRole);
      const target =
        loginRedirectUrl && (loginRedirectUrl === home || loginRedirectUrl.startsWith(`${home}?`) || loginRedirectUrl.startsWith(`${home}/`))
          ? loginRedirectUrl
          : home;
      setTimeout(() => history.push(target), 0);
      loginRedirectUrl = this.defaultLoginRedirectUrl;
    } else {
      /*
              User is member
              User must be on unAuthorized page or just logged in
              Redirect to dashboard or loginRedirectUrl
              */
      setTimeout(() => history.push(redirectUrl), 0);
      loginRedirectUrl = this.defaultLoginRedirectUrl;
    }
  }

  render() {
    return this.state.accessGranted ? <>{this.props.children}</> : null;
  }
}

FuseAuthorization.contextType = AppContext;

export default withRouter(FuseAuthorization);
